export const generateVideoThumbnail = video => {
  const videoExt = /mp4|webm|ogv/
  return video
    .replace('upload/', 'upload/w_300,h_300,c_fill/')
    .replace(videoExt, 'jpg')
}
